import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconCall.tsx
const OutlinedFilledCall = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M797-95q-122 0-247-58T319-317Q212-424 153.5-549.5T95-796q0-29 20-49.5t49-20.5h140q31 0 50.5 16.5T381-802l27 110q4 26-1.5 46T385-612l-104 95q22 36 47 68t57 62q33 35 66.5 61t68.5 44l100-101q17-18 38-24t45 0l99 23q31 9 47.5 29t16.5 50v141q0 29-20.5 49T797-95Z" })
});
const OutlinedCall = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M797-95q-122.1 0-247.05-58Q425-211 318.5-317.5 212-424 153.5-549.46 95-674.92 95-796q0-29.43 20-49.71Q135-866 164-866h140q31 0 50.5 16.5T381-802l26.93 109.64Q412-666 406.5-646t-21.73 34.23L281-517q22 36 47 68t57 62q33 35 66.5 61t68.5 44l100-101q17-18 38.15-24t44.85 0l99 23q31 9 47.5 29.04Q866-334.91 866-305v141q0 29.57-20.36 49.29Q825.29-95 797-95ZM234-600l80-75-22-96H191q1 36 10.46 77.44Q210.91-652.12 234-600Zm372 367q36 17 79.5 28t85.5 14v-102.82L683-313l-77 80ZM234-600Zm372 367Z" })
});
const RoundedFilledCall = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M797-95q-122 0-247-58T319-317Q212-424 153.5-549.5T95-796q0-29 20-49.5t49-20.5h140q31 0 50.5 16.5T381-802l27 110q4 26-1.5 46T385-612l-104 95q22 36 47 68t57 62q33 35 66.5 61t68.5 44l100-101q17-18 38-24t45 0l99 23q31 9 47.5 29t16.5 50v141q0 29-20.5 49T797-95Z" })
});
const RoundedCall = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M797-95q-122.1 0-247.05-58Q425-211 318.5-317.5 212-424 153.5-549.46 95-674.92 95-796q0-29.43 20-49.71Q135-866 164-866h140q31 0 50.5 16.5T381-802l26.93 109.64Q412-666 406.5-646t-21.73 34.23L281-517q22 36 47 68t57 62q33 35 66.5 61t68.5 44l100-101q17-18 38.15-24t44.85 0l99 23q31 9 47.5 29.04Q866-334.91 866-305v141q0 29.57-20.36 49.29Q825.29-95 797-95ZM234-600l80-75-22-96H191q1 36 10.46 77.44Q210.91-652.12 234-600Zm372 367q36 17 79.5 28t85.5 14v-102.82L683-313l-77 80ZM234-600Zm372 367Z" })
});
const SharpFilledCall = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M777-95q-108 0-230-59T319-319Q212-424 153.5-543.5T95-776v-90h272l51 224-138 126q24 37 49.5 69t53.5 61q32 32 66 58.5t71 46.5l135-137 211 49v274h-89Z" })
});
const SharpCall = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M777-95q-108 0-230-59T319-319Q212-424 153.5-543.51 95-663.02 95-776v-90h272l51 224-138 126q24.16 37.15 49.58 69.07Q355-415 383.03-385.97 415-354 449-327.5t71 46.5l135-137 211 48.58V-95h-89ZM234-600l80-75-22-96H191q-2 33 8.5 74.5T234-600Zm372 367q34 16 77.5 27.5T771-191v-102.82L683-313l-77 80ZM234-600Zm372 367Z" })
});
const componentMap = {
	outlined: OutlinedCall,
	"outlined-fill": OutlinedFilledCall,
	rounded: RoundedCall,
	"rounded-fill": RoundedFilledCall,
	sharp: SharpCall,
	"sharp-fill": SharpFilledCall
};
const IconCall = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconCall };